import { PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from './store';
import { toggleRTL, toggleTheme, toggleLocale, toggleMenu, toggleLayout, toggleAnimation, toggleNavbar, toggleSemidark, toggleSidebar } from './store/themeConfigSlice';
import store from './store';
import dayjs from 'dayjs';
import RelativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from "dayjs/plugin/localeData";
import "dayjs/locale/en";
import "dayjs/locale/ru";

import ScrollToHash from './components/ScrollToHash';
import i18next from 'i18next';
import { selectSettings } from './store/authSlice';
import { TourProvider } from './contexts/TourContext';
import { SmartRulesProvider } from './contexts/SmartRulesContext';
import CategorySync from './components/Initialization/CategorySync';
import GlobalTour from './components/Tour/GlobalTour';

dayjs.extend(RelativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);

function App({ children }: PropsWithChildren) {
    const themeConfig = useSelector((state: IRootState) => state.themeConfig);
    const dispatch = useDispatch();
    const settings = useSelector(selectSettings);
    const preferences = settings?.preferences;

    const hideSidebarByDefault = preferences && preferences?.hideSidebarByDefault !== undefined ? preferences.hideSidebarByDefault : false;

    useEffect(() => {
        const initialTheme = localStorage.getItem('theme') || preferences?.defaultTheme || themeConfig.theme;
        dispatch(toggleTheme(initialTheme));
        dispatch(toggleMenu(localStorage.getItem('menu') || themeConfig.menu));
        dispatch(toggleLayout(localStorage.getItem('layout') || themeConfig.layout));
        dispatch(toggleRTL(localStorage.getItem('rtlClass') || themeConfig.rtlClass));
        dispatch(toggleAnimation(localStorage.getItem('animation') || themeConfig.animation));
        dispatch(toggleNavbar(localStorage.getItem('navbar') || themeConfig.navbar));
        dispatch(toggleLocale(localStorage.getItem('i18nextLng') || themeConfig.locale));
        dispatch(toggleSemidark(localStorage.getItem('semidark') || themeConfig.semidark));
        dispatch(toggleSidebar(!hideSidebarByDefault));
    }, []);

    useEffect(() => {
        i18next.on("languageChanged", (lng: string) => {
            dayjs.locale(lng);
        });
    }, []);

    return (
        <TourProvider>
            <SmartRulesProvider>
                <CategorySync />
                <div
                    className={`${(store.getState().themeConfig.sidebar && 'toggle-sidebar') || ''} ${themeConfig.menu} ${themeConfig.layout} ${themeConfig.rtlClass
                        } main-section antialiased relative font-nunito text-sm font-normal`}
                >
                    <ScrollToHash />
                    {children}
                </div>
                <GlobalTour />
            </SmartRulesProvider>
        </TourProvider>
    );
}

export default App;
